<template>
  <div>
    <mu-list-item :title="cartitem.goodsName" :key="cartitem.id" class="list-box" :class="[isRightTriggle?'hasright':'']" v-if="cartitem.sourceType=='1'||cartitem.sourceType==null|| cartitem.sourceType==0"  @click="clickItem(cartitem.goodsId,cartitem.skuId || 0)">
      <mu-checkbox name="group" :nativeValue="cartitem.favId" v-model="value" class="list-radio" v-show="isCheckBox" />
      <imgs :width="width" :height="height" :imagePath="cartitem.imagePath && cartitem.imagePath.imagePath" slot="leftAvatar"></imgs>
      <div class="listItem">
        <p class="price">￥{{cartitem.salePrice || cartitem.orderGoodsPrice || cartitem.goodsPrice}}
          <label class="count" v-show="cartitem.goodsNum">x{{cartitem.goodsNum}}</label>
        </p>
      </div>
      <div class="clear"></div>
      <img v-if="isRightTriggle" class="user-right" src="/static/images/ic_more_3x.png">
    </mu-list-item>
    <template v-if="cartitem.sourceType=='2'">
      <!-- goods信息 -->
      <mu-list-item :title="cartitem.goodsName" :key="cartitem.id" class="list-box diy-title" :class="[isRightTriggle?'hasright':'']">
        <div class="point"></div>
        <div class="listItem">
          <p class="price">￥{{cartitem.salePrice || cartitem.orderGoodsPrice}}
            <label class="count" v-show="cartitem.goodsNum">x{{cartitem.goodsNum}}</label>
          </p>
        </div>
      </mu-list-item>
      <!-- goods.sub 信息  v-bind:class="[subindex == (cartitem.subCartGoods.length -1 || cartitem.subGoodsOrderMsgs.length -1)?'last point':'point']" -->
      <template v-for="(sub,subindex) in (cartitem.subCartGoods ||cartitem.subGoodsOrderMsgs)" >
        <mu-list-item :title="sub.goodsName" :key="sub.id" class="list-box diy-list" :class="[isRightTriggle?'hasright':'']" @click="clickItem(sub.goodsId,sub.skuId || 0)">
          <div class="point" v-if="cartitem.subCartGoods" v-bind:class="[subindex == (cartitem.subCartGoods.length -1 ) ?'last':'']"></div>
          <div class="point" v-if="cartitem.subGoodsOrderMsgs" v-bind:class="[subindex == (cartitem.subGoodsOrderMsgs.length -1) ?'last':'']"></div>
          <imgs :imagePath="sub.imagePath && sub.imagePath.imagePath" slot="leftAvatar"></imgs>
          <div class="listItem">
            <p class="price">￥{{sub.salePrice || sub.orderGoodsPrice}}
              <label class="count" v-show="sub.goodsNum">x{{sub.goodsNum}}</label>
            </p>
          </div>
          <div class="clear"></div>
          <img v-if="isRightTriggle" class="user-right" src="/static/images/ic_more_3x.png">
        </mu-list-item>
      </template>
    </template>
  </div>
</template>
<script>
import imgs from '@components/image/image';
export default {
  props: {
    isDIY: false, //是否是div商品
    cartitem: "",
    selvalue: "",
    isCheckBox: false, //是否有复选框
    isRightTriggle: false, //是否有向右的箭头
    width: [Number,String],
    height: [Number,String]
  },
  data() {
    return {
      value: this.selvalue
    }
  },
  methods: {
    clickItem: function(goodid,skuId) {
      if(skuId == undefined){
        skuId = 0;
      }
      location.href = '/main/goodsDetail?goodsId='+ goodid +'&skuId=' + skuId || 0
      
      //this.$emit('clickItem', index);
    },

  },
  components: {
    imgs,
  },
  watch: {
    selvalue(val) {
      this.value = val;
    },
    value(val) { 
      this.$emit("on-result-change", val);
    },

  },
}

</script>
<style lang="scss" rel="stylesheet/scss">
@import 'src/common/sass/mixin.scss';
.mu-list {
  .point {
    width: 0.2rem;
    height: 0.2rem;
    background: #D8D8D8;
    position: absolute;
    left: 0.3rem;
    top: 0.175rem;
    border-radius: 50%;
    &:before,
    &:after {
      content: "";
      display: inline-block;
      width: 1px;
      position: absolute;
      top: 50%;
      border-right: 1px dashed #C2C2C2;
    }
    &:before {
      left: 50%;
      top: -0.15rem;
      height: 0.1rem;
    }
    &:after {
      left: 50%;
      top: 115%;
      bottom: 0rem;
      height: 1.4rem;
    }
  }
  .point.last {
    &:after {
      height: 0rem;
    }
  }
  .diy-title {
    .mu-item {
      padding: 0.175rem 0.4rem 0.175rem 0.8rem !important;
    }
    .point {
      background: #E60012;
      top: 0.5rem;
      &:before {
        height: 0rem;
      }
    }
  }
  .diy-list {

    .mu-item {
      padding: 0.175rem 0.4rem 0.175rem 2.4rem;
      .mu-item-left {
        left: 0.8rem;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// myOrdersItem.vue?4c948280